module.exports = __webpack_public_path__ + "img/WhiteMouseEnergy.f0e4d059.png";